<template>
  <div id="descuento-permanente">

    <div class="sub-seccion" v-if="!deshabilitado || descuento_permanente_copy">
      <div class="titulo-sub-seccion">
        <span>Descuento permanente</span>
      </div>
      <div class="contenido-sub-seccion">
        <v-container v-if="descuento_permanente_copy !== null" class="pa-2">
          <div class="d-flex justify-space-between align-center container-descuento">
            <div class="input-descuento">
              <v-text-field
                v-model="descuento_permanente_copy"
                label="Descuento"
                value=descuento_permanente_copy
                type="number"
                :rules="reglas_descuentos(descuento_permanente_copy)"
                :disabled=deshabilitado
                :min="0"
                :max="100"
              >
                <div slot="append">
                  <v-icon :class="deshabilitado ? 'deshabilitado' : ''">percent</v-icon>
                </div>
              </v-text-field>
            </div>

            <v-icon v-if="!deshabilitado" class="icon-delete mr-4" @click="descuento_permanente_copy = null">delete</v-icon>
          </div>
        </v-container>

        <div v-if="!deshabilitado && this.descuento_permanente_copy == null" class="mt-2 ml-2 pb-4">
          <a v-if="this.descuento_permanente_copy == null" class="label-agregar-descuento" @click="descuento_permanente_copy = 1">Agregar descuento</a>
        </div>

        <!-- Slot custom, para poder insertar mensaje debajo del input -->
        <slot name="mensaje-informativo"></slot>
      </div>
    </div>

  </div>
</template>

<script>

export default {
  name: 'DescuentoPermanente',
  props:{
    descuento_permanente: { type: undefined, default: () => null },
    deshabilitado: { type: Boolean, default: false } // Flag para deshabilitar los inputs
  },
  data(){
    return {
      descuento_permanente_copy: [], // Copia de la prop, para actualizarla emitiendo evento

      // Reglas para la validación
      reglas_descuentos: (valor) => [(valor > 0 && valor <= 100) || 'El descuento debe ser mayor a 0 y menor a 100']
    };
  },
  watch:{

    /**
     * Necesario para actualizar los descuentos en el padre con los cambios hechos en este componente
     */
    descuento_permanente_copy: {
      handler: function (new_value) {
        this.$emit('update:descuento_permanente', new_value);
      },
      deep: true
    }
  },
  mounted(){
    this.descuento_permanente_copy = _.cloneDeep(this.descuento_permanente); // Lo clono para poder modificarlo
  },
  methods: {

    /**
     * Actualiza la copia del descuento permanente con los cambios hechos en el padre 
     */
    actualizarDescuentoPermanente(nuevo_descuento_permanente) {
      this.descuento_permanente_copy = _.cloneDeep(nuevo_descuento_permanente);
    }
  }
};
</script>

<style lang="scss">
#descuento-permanente{
  .container-descuento{
    background-color: color(fondo-claro);
    margin-bottom: 8px;
  }

  .input-descuento {
    max-width: 85px;
    margin-left: 16px;
    margin-right: 16px;
  }

  .deshabilitado{
    color:color(gris-deshabilitado);
  }

  // Desplazo las flechas del input number
  .input-descuento input::-webkit-outer-spin-button,
  .input-descuento input::-webkit-inner-spin-button {
      margin-left:5px;
  }
}
</style>